import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileTif"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 8.25V6.75H16.5V17.25H18V12.75H21.75V11.25H18V8.25H22.5ZM9 8.25H11.25V15.75H9V17.25H15V15.75H12.75V8.25H15V6.75H9V8.25ZM1.5 8.25H3.75V17.25H5.25V8.25H7.5V6.75H1.5V8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileTif.vue"]]);
